import { ReactElement, PropsWithChildren } from 'react';

import FloatingMenu from 'components/FloatingMenu';

function BaseLayout(
  props: PropsWithChildren<any>
): ReactElement<HTMLDivElement> {
  return (
    <>
      <FloatingMenu />
      <div className="bg-gray-100">
        <div className="mx-3 py-5 lg:mx-auto lg:max-w-5xl">
          {props.children}
          <footer className="py-5">
            <p className="text-center text-sm text-gray-500">
              &copy; 2021 - M. Akbar Nugroho
            </p>
          </footer>
        </div>
      </div>
    </>
  );
}

export default BaseLayout;
